import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Calculator, Layers } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import { KNOWLEDGE_ARTICLES } from "@/data/knowledgeBase";
import { VISIBLE_PRODUCTS } from "@/data/products";

const BazaWiedzy = () => {
  const categories = Array.from(new Set(KNOWLEDGE_ARTICLES.map((a) => a.category)));

  return (
    <Layout>
      <SEOHead
        title="Baza wiedzy o naklejkach 3D – poradniki techniczne"
        description="Baza wiedzy o naklejkach 3D: przygotowanie plików, dobór folii, trwałość żywicy, montaż, koszty i proces zamówienia dla firm. Poradniki techniczne producenta."
      />

      <section className="gradient-navy py-20">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <BookOpen className="w-10 h-10 text-accent mx-auto mb-4" aria-hidden="true" />
          <h1 className="text-3xl lg:text-5xl font-bold text-primary-foreground mb-5">
            Baza wiedzy o naklejkach 3D
          </h1>
          <p className="text-primary-foreground/80 text-lg leading-relaxed">
            Poradniki techniczne dla firm: przygotowanie plików, dobór folii, trwałość żywicy
            poliuretanowej, montaż, koszty i przebieg zamówienia.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="flex flex-wrap gap-2 mb-10" aria-label="Kategorie artykułów">
            {categories.map((c) => (
              <span
                key={c}
                className="text-xs font-semibold px-3 py-1.5 rounded-full bg-secondary text-secondary-foreground border border-border"
              >
                {c}
              </span>
            ))}
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {KNOWLEDGE_ARTICLES.map((a) => (
              <article
                key={a.slug}
                className="bg-card border border-border rounded-xl p-7 hover:border-accent/40 hover:shadow-lg transition-all flex flex-col"
              >
                <span className="text-xs font-semibold text-accent uppercase tracking-wide mb-3">
                  {a.category}
                </span>
                <h2 className="text-xl font-bold text-foreground mb-3 leading-snug">
                  <Link to={`/baza-wiedzy/${a.slug}`} className="hover:text-accent transition-colors">
                    {a.title}
                  </Link>
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-5 flex-1">{a.excerpt}</p>
                <Link
                  to={`/baza-wiedzy/${a.slug}`}
                  className="text-accent font-semibold text-sm flex items-center gap-1"
                >
                  Czytaj poradnik <ArrowRight className="w-4 h-4" aria-hidden="true" />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-secondary/40 border-y border-border">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-2xl font-bold text-foreground mb-8 flex items-center gap-2">
            <Layers className="w-5 h-5 text-accent" aria-hidden="true" /> Produkty opisane w bazie wiedzy
          </h2>
          <div className="grid gap-4 sm:grid-cols-2">
            {VISIBLE_PRODUCTS.map((p) => (
              <Link
                key={p.slug}
                to={`/${p.slug}`}
                className="block p-5 bg-card border border-border rounded-lg hover:border-accent/40 transition-colors"
              >
                <h3 className="text-foreground font-semibold mb-1">{p.name}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{p.metaDescription}</p>
              </Link>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/kalkulator"
              className="inline-flex items-center gap-2 bg-accent text-accent-foreground font-semibold px-6 py-3 rounded-lg hover:opacity-90 transition-opacity"
            >
              <Calculator className="w-4 h-4" aria-hidden="true" /> Wyceń naklejki w kalkulatorze
            </Link>
            <Link
              to="/zastosowania-branzowe"
              className="inline-flex items-center gap-2 border border-border text-foreground font-semibold px-6 py-3 rounded-lg hover:border-accent/40 transition-colors"
            >
              Zastosowania branżowe
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BazaWiedzy;
